import { useState } from 'react';
import { ReactFormGenerator } from 'react-form-builder2';
import { useNavigate } from 'react-router-dom';

import { Honeybadger } from '@honeybadger-io/react';

import { requestApi } from 'api/Api';

import { ia } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';
import Allowed from 'components/shared/Permissions/Allowed';
import Popover from 'components/shared/Popovers/Popover/Popover';

import Button from '../../Buttons/Button';
import Modal from '../Modal';

const CustomForms = ({
  showCustomForms,
  hideCustomForms,
  selectedForm,
  appointment,
  sendFormsToKiosk,
  kiosks,
  appendParentSelector = true,
  invalidateQuery = () => {},
  className = '',
  isAptDisabled = false
}) => {
  const [loading, setLoading] = useState(false);
  const answerData = selectedForm.response ? JSON.parse(selectedForm.response.json.fields) : null;
  const navigate = useNavigate();

  const handleFormSubmit = async (e, responseId, formId, formVersion) => {
    setLoading(true);
    try {
      const params = {
        responseId,
        formId,
        json: { fields: JSON.stringify(e) },
        appointmentId: appointment.id,
        patientId: appointment.patient.id,
        formVersion
      };

      const res = await requestApi({ url: '/api/form/upsert_response', params, navigate });

      if (res.upsert) {
        showAlert({ title: 'Form Saved!', color: 'success' });
        invalidateQuery();
      } else {
        Honeybadger.notify(`There's been an unexpected error, please try again later.`);
      }
    } catch (err) {
      Honeybadger.notify(`There's been an unexpected error, please try again later. ${err}`);
    }
    setLoading(false);
  };

  const showActions = ia(kiosks) && !isAptDisabled;

  const options = [
    {
      label: 'Send to Kiosk',
      children: ia(kiosks)
        ? kiosks?.map((kiosk) => {
            return {
              label: kiosk.name,
              icon: 'kiosk',
              customColor: kiosk.color,
              onClick: () => sendFormsToKiosk([selectedForm.id], kiosk.id)
            };
          })
        : null
    }
  ];

  return (
    <Modal
      isOpen={showCustomForms}
      handleClose={hideCustomForms}
      className={className}
      title={selectedForm.name}
      {...(appendParentSelector && {
        appendParentSelector: document.getElementById('AppointmentPreviewModal') || document
      })}
      slideFromRight
      subModal
      isLarge
      prevButton={
        <Button
          outlined
          color="neutral"
          icon="arrow-left-linear"
          onClick={hideCustomForms}
          className="!mr-3"
        />
      }
      footer={
        <div className="flex w-full items-center justify-between">
          <Button text="Cancel" color="neutral" outlined onClick={hideCustomForms} />
          <div>
            <Allowed requiredPermissions="kiosk.read">
              {showActions && <Popover isFixed position="left" options={options} />}
            </Allowed>
          </div>
        </div>
      }>
      <div className="new-forms">
        <ReactFormGenerator
          answer_data={answerData}
          read_only={isAptDisabled}
          data={selectedForm?.json?.fields}
          submitButton={
            <div className="flex w-full justify-center pb-2 pt-3">
              <Button text="Save" buttonType="submit" loading={loading} disabled={isAptDisabled} />
            </div>
          }
          onSubmit={(e) =>
            handleFormSubmit(
              e,
              selectedForm.response ? selectedForm.response.id : null,
              selectedForm.id,
              selectedForm.version
            )
          }
        />
      </div>
    </Modal>
  );
};

export default CustomForms;
